export default {
  getMoviesSuccess: 'Successfully loaded movies',
  getMoviesFailure: 'Couldn\'t get movies :(',
  showMovieSuccess: 'Successfully loaded movie',
  showMovieFailure: 'Error on movie load!',
  createMovieSuccess: 'Successfully created a movie!',
  createMovieFailure: 'Error! Movie might exist already.',
  getFavoritesFailure: 'Couldn\'t load favorites!',
  createFavoriteFailure: 'Error on create favorite!',
  destroyFavoriteFailure: 'Error on removing favorite!'
}



// WEBPACK FOOTER //
// ./src/main/movies/messages.js